"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
var _exportNames = {
  configureAxios: true,
  getAxios: true
};
exports.default = exports.getAxios = exports.configureAxios = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _debouncePromise = _interopRequireDefault(require("debounce-promise"));

var _genericCRUD = require("./genericCRUD");

Object.keys(_genericCRUD).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  exports[key] = _genericCRUD[key];
});
var MAX_ATTEMPTS = 3;
var instanceMap = {};
var tokenMap = {};
var instanceCounter = 0;

var defaultGetAccessToken = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", undefined);

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function defaultGetAccessToken() {
    return _ref.apply(this, arguments);
  };
}();

var configureAxios = function configureAxios(_ref2) {
  var _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? "instance-" + instanceCounter++ : _ref2$name,
      _ref2$onGetAccessToke = _ref2.onGetAccessToken,
      onGetAccessToken = _ref2$onGetAccessToke === void 0 ? defaultGetAccessToken : _ref2$onGetAccessToke,
      _ref2$config = _ref2.config,
      config = _ref2$config === void 0 ? {} : _ref2$config;

  var instance = instanceMap[name] = _axios.default.create(config);

  var fetchToken = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(context) {
      var token;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return onGetAccessToken((0, _extends2.default)({}, config, context));

            case 2:
              token = _context2.sent;

              if (token) {
                tokenMap[name] = token;
              }

              return _context2.abrupt("return", token);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchToken(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var loadToken = (0, _debouncePromise.default)(fetchToken, 0); // add bearer token to outgoing requests

  instance.interceptors.request.use( /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(config) {
      var token, headers;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = tokenMap[name];

              if (_context3.t0) {
                _context3.next = 5;
                break;
              }

              _context3.next = 4;
              return loadToken(config);

            case 4:
              _context3.t0 = _context3.sent;

            case 5:
              token = _context3.t0;
              headers = (0, _extends2.default)({}, config.headers); // if the token is set, use it

              if (token) {
                headers.Authorization = "Bearer " + token;
              }

              return _context3.abrupt("return", (0, _extends2.default)({}, config, {
                headers: headers
              }));

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }()); // setup response interceptor to retry a call that received a 401

  instance.interceptors.response.use(undefined, /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(error) {
      var config, attemptCount;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!error || !error.response || error.response.status !== 401)) {
                _context4.next = 2;
                break;
              }

              throw error;

            case 2:
              // Pull the config from the original failed request. (this has the url, post method, headers etc)
              config = error.config; // pull retryCount from the config (should be undefined by default)

              attemptCount = config.attemptCount || 1;

              if (!(attemptCount >= MAX_ATTEMPTS)) {
                _context4.next = 6;
                break;
              }

              throw error;

            case 6:
              // set the retry count on the config, so we can prevent infinite retries
              config.attemptCount = attemptCount + 1;
              _context4.prev = 7;
              _context4.next = 10;
              return loadToken(config);

            case 10:
              _context4.next = 12;
              return instance(config);

            case 12:
              return _context4.abrupt("return", _context4.sent);

            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4["catch"](7);
              throw (0, _extends2.default)({}, _context4.t0, {
                originalError: error
              });

            case 18:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[7, 15]]);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }());
  return instance;
};

exports.configureAxios = configureAxios;

var getAxios = function getAxios(name, creationConfig) {
  return instanceMap[name] || configureAxios((0, _extends2.default)({
    name: name
  }, creationConfig));
};

exports.getAxios = getAxios;
var _default = getAxios;
exports.default = _default;